import { useUIContext } from 'lib/context/UIContext/UIContext';
import { formatDate } from 'lib/helpers/dateUtils';

import Typography from 'components/shared/Typography/Typography';

import TableCell from '../ReceiptTable/components/TableCell';

const DescriptionHeaderCell = ({ dateOfService, colSpan }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  if (!dateOfService) return null;

  return (
    <tr className="h-8 items-center gap-2.5 bg-neutral-50">
      <TableCell colSpan={isMobile ? 1 : colSpan} bodyClassName="justify-start">
        <div className="flex items-center gap-2.5">
          <Typography variant="label" size="medium" weight="medium" color="neutral-700">
            Date of service
          </Typography>
          <Typography variant="label" size="medium" className="italic" color="neutral-500">
            {formatDate(dateOfService)}
          </Typography>
        </div>
      </TableCell>
    </tr>
  );
};

export default DescriptionHeaderCell;
